import SafeLink from "./SafeLink";

export default SafeLink;
